/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC, useEffect, useState } from "react";
import { offEvent, onEvent } from "@adapptio/lib-shared";
import { DOC_ERROR_SEVERITY } from "@adapptio/lib-blueprint";

import { ActionModel } from "../../Common/ActionModel";
import { ErrorList } from "../../../../ui/components/ErrorList/ErrorList";
import { ERROR_LIST_CATEGORY } from "../../../../ui/components/ErrorList/ErrorListTypes";
import { Panel, PANEL_STYLE } from "../../../../ui/components/Panel";

export interface IActionEditorConsoleContentProps {
	model: ActionModel;
	severityFilter?: Set<DOC_ERROR_SEVERITY> | null;
}

export const ActionEditorConsoleContent: FC<IActionEditorConsoleContentProps> = ({
	model,
	severityFilter
}) => {
	const [ errors, setErrors ] = useState(() => model.getErrors());

	useEffect(() => {
		const handleErrorEvent = () => setErrors(model.getErrors());

		onEvent(model.onParseErrors, handleErrorEvent);

		return () => {
			offEvent(model.onParseErrors, handleErrorEvent);
		};
	}, [ model ]);

	return (
		<Panel style={PANEL_STYLE.BASE} scroll={true}>
			<ErrorList
				errorGroups={[ errors ]}
				category={ERROR_LIST_CATEGORY.ALL}
				severityFilter={severityFilter}
			/>
		</Panel>
	);
};
